import { Button, Col, Empty, message, Modal, Row, Select } from 'antd';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';

import { DateRange } from '../../types/base';
import { MarketingActivity } from '../../types/marketingActivity';
import { Enrollment, Sku } from '../enrollment/Enrollment';
import { ADMISSION_QUIZ, skusListQuery, transferEnrollmentToAnotherSkuMutation } from './UserDetail';
import { ALL_USERS_QUERY } from './Users';

interface Props {
  enrollment: Enrollment;
  userId: number;
  transferNeedData: {
    marketingActivityFilterOptions: MarketingActivity[];
    selectedMarketingActivityFilter: number;
    clockInDateRange: DateRange;
  };
}

interface State {
  skuId: any;
  variables: {
    ids?: number[];
  };
  isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: boolean;
}

export class TransferSkuToAnotherWithCourse extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      skuId: '',
      variables: {},
      isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: false,
    };
    this.cancelTransferSkuOperation = this.cancelTransferSkuOperation.bind(this);
    this.onReviewTransferEnrollmentToAnotherSkuClick = this.onReviewTransferEnrollmentToAnotherSkuClick.bind(this);
  }

  cancelTransferSkuOperation() {
    this.setState({
      isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: false,
      skuId: '',
    });
  }

  onReviewTransferEnrollmentToAnotherSkuClick() {
    this.setState({ isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: true });
  }

  render() {
    const { enrollment, userId } = this.props;
    const quizEndAt = enrollment.sku.quizEndAt;
    const skuGroupIds = enrollment.sku.groups.map(v => v.id);

    if (!quizEndAt) {
      return null;
    }
    const {
      marketingActivityFilterOptions,
      selectedMarketingActivityFilter,
      clockInDateRange,
    } = this.props.transferNeedData;
    const activityId = marketingActivityFilterOptions[selectedMarketingActivityFilter].id;
    return (
      <>
        <Button
          style={{ marginLeft: 8 }}
          type="primary"
          icon="plus"
          onClick={this.onReviewTransferEnrollmentToAnotherSkuClick}
        >
          调课
        </Button>
        <Mutation
          mutation={transferEnrollmentToAnotherSkuMutation}
          variables={{
            id: enrollment.id,
            skuId: this.state.skuId,
            sameTeacher: true,
          }}
          refetchQueries={[
            {
              query: ALL_USERS_QUERY,
              variables: {
                activityId,
                ids: [userId],
                dateRange: clockInDateRange,
                miniGameName: ADMISSION_QUIZ,
              },
            },
          ]}
        >
          {(transferEnrollmentToAnotherSku, { loading }) => {
            return (
              <Modal
                visible={this.state.isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible}
                onOk={async () => {
                  if (!this.state.skuId) {
                    message.error('请选择要调课的sku！');
                    return;
                  }
                  if (loading) {
                    return;
                  }
                  try {
                    await transferEnrollmentToAnotherSku();
                    message.success('操作成功');
                    this.setState({ isOfferTransferEnrollmentToAnotherSkuPopupConfirmVisible: false });
                  } catch (e) {
                    message.error('失败！');
                  }
                }}
                onCancel={this.cancelTransferSkuOperation}
              >
                <Row gutter={24}>
                  <Col span={24}>
                    <div>
                      <Col span={24}>
                        <Query
                          query={skusListQuery}
                          variables={{
                            skuGroupIds,
                            startRange: {
                              from: enrollment.sku.start,
                              to: enrollment.sku.start,
                            },
                          }}
                        >
                          {({ loading, error, data }) => {
                            if (error) return <div>{error.message}</div>;
                            if (loading) return <div>loading...</div>;
                            if (!data) {
                              // @ts-ignore
                              return <Empty />;
                            }
                            const skus = data.skus;
                            const currentSku = enrollment.sku;
                            const selectSkus = skus.filter((item: Sku) => item.course.id !== currentSku.course.id);
                            return (
                              <Select
                                style={{ width: '100%' }}
                                placeholder="选择sku"
                                onChange={(value: number) => {
                                  this.setState({
                                    skuId: value,
                                  });
                                }}
                              >
                                {selectSkus.map((sku: { id: number; name: string }) => {
                                  return (
                                    <Select.Option value={sku.id} key={sku.id}>
                                      {sku.name}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            );
                          }}
                        </Query>
                      </Col>
                    </div>
                  </Col>
                </Row>
              </Modal>
            );
          }}
        </Mutation>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/TransferSkuWidthCourse.tsx